import Especialidades from './services/Especialidades'
import Cobranca from './services/Cobranca'

export default {
  Especialidades,
  Cobranca
}
